import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Color, Grid, Type } from '../../app/StyleGuide';

// ---------------------------------------------------------------------------
// Footer
// ---------------------------------------------------------------------------

const StyledFooter = styled.div`
  background: ${Color.Gray._01};
  display: grid;
  grid-template-columns: 1fr max-content;
  padding: ${Grid._4} ${Grid._7} ${Grid._4} 0;
  color: ${Color.Gray._70};
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  line-height: ${Type.Leading.normal};
  align-items: start;

  & > div:nth-child(1) {
    display: none;
  }

  & > div:nth-child(2) {
    padding: 0 ${Grid._5};
    display: block;

    .icon {
      display: flex;
      align-items: center;
      color: ${Color.Gray._90};
      margin-right: ${Grid._3};
      font-size: ${Type.Scale._2};
    }
  }

  a {
    color: ${Color.Gray._90};
    font-weight: ${Type.Weight.bold};
    display: flex;
    cursor: pointer;
    text-align: left;
    width: 100%;
    text-decoration: none;
  }

  a:hover span {
    text-decoration: underline;
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: ${Grid._12} 1fr max-content;
    column-gap: ${Grid._5};

    & > div:nth-child(1) {
      display: block;
      padding-left: ${Grid._5};
      text-align: center;
    }

    & > div:nth-child(2) {
      padding-left: 0;
    }
  }
`;

export function Footer(props: React.HTMLAttributes<HTMLDivElement>) {
  return <StyledFooter {...props} />;
}

// ---------------------------------------------------------------------------
// UpNext
// ---------------------------------------------------------------------------

type UpNextProps = {
  name: string;
  iconClass: string;
  onClick: () => void;
};

export function UpNext({ name, iconClass, onClick }: UpNextProps) {
  return (
    <>
      <div>Next</div>
      <div>
        <a onClick={onClick} data-tracking-component="up-next" data-tracking-id={name}>
          <i className={'icon ' + iconClass} />
          <span>{name}</span>
        </a>
      </div>
    </>
  );
}
